import { Typography } from '@mui/material';
import { INode } from '../../NewFormBuilder/Context/FormBuilderContext';

interface ShortTextProps {
  node: INode;
}

export function ShortText({ node }: ShortTextProps) {
  const styles = node.data.styles;

  return (
    <Typography
      style={{
        color: styles.shortText?.color || 'rgb(71, 84, 103)',
        whiteSpace: 'pre-wrap',
        fontSize: `${styles.shortText?.fontSize || 14}px`,
        lineHeight: '150%',
        fontFamily: styles.shortText?.fontFamily || 'Roboto, sans-serif',
        fontWeight: styles.shortText?.isBold ? '700' : '400',
        fontStyle: styles.shortText?.isItalic ? 'italic' : 'normal',
        textDecoration: styles.shortText?.isUnderlined ? 'underline' : 'none',
        width: '100%',
        textAlign: styles.shortText?.textAlign || 'left',
        letterSpacing: '0.5px',
      }}
    >
      {node.data.text}
    </Typography>
  );
}
